export interface UserStats {
  sessionCount: number;
  challengesSent: number;
  linksCopied: number;
  lastSessionAt: Date;
}

export interface DodoSubscriptionEmbed {
  subscriptionId: string;
  status: 'active' | 'on_hold' | 'cancelled' | 'expired' | 'paused' | 'failed';
  planId: 'monthly' | 'annual' | 'lifetime';
  nextBillingDate: string | null;
  currency: string;
  unitPrice: number;
  customerId: string | null;
  createdAt: string;
}

export interface User {
  uid: string;
  email: string;
  displayName: string;
  photoURL?: string;
  subscriptionTier: SubscriptionTier;
  dodoSubscription?: DodoSubscriptionEmbed;
  friends: string[];
  progress: UserProgress;
  stats: UserStats;
  createdAt: Date;
}

export enum SubscriptionTier {
  FREE = 'free',
  PREMIUM = 'premium',
  LIFETIME = 'lifetime'
}

export interface UserProgress {
  completedVideos: string[];
  completedQuizzes: string[];
  quizScores: { [quizId: string]: QuizScore };
  watchHistory: WatchHistoryItem[];
  currentStreak: number;
  longestStreak: number;
  lastActiveDate: Date;
  totalXp: number;
  dailyFirstQuizDone: boolean; // se resetea cada día en el backend
}

export interface QuizScore {
  score: number;
  maxScore: number;
  pct: number;
  completedAt: Date;
  timeTaken?: number;
}

export interface WatchHistoryItem {
  videoId: string;
  watchedAt: Date;
  progress: number;
  completed: boolean;
}
